module.exports = __webpack_public_path__ + "static/media/raven_sad_04.232d3a3c.svg";